import cardImage from './generic-cc-icon.svg';

export const CreditCardsComponent = {
    template: `
        <oo-card id="ca-customer-credit-cards">
            <oo-card-header>
                <p>Payment Options</p>
            </oo-card-header>

            <oo-card-body>
                <div class="missing-card" ng-if="!$ctrl.accountService.data.cards.length">
                    <img src=${cardImage}>
                    <p c-type="title-sm-primary">No Saved Payments</p>
                </div>
                <ul class="card-list" ng-if="$ctrl.accountService.data.cards.length">
                    <li ng-repeat="card in $ctrl.accountService.data.cards" >
                        <credit-card-pane credit-card="card"></credit-card-pane>
                    </li>
                </ul>
                <div c-col="fill" class="disclaimer">
                    <p c-type="body-sm-primary italic center">{{$ctrl.disclaimer}}</p>
                </div>

            </oo-card-body>
        </oo-card>
    `,
    controller: class {
        constructor(accountService) {
            'ngInject';
            this.accountService = accountService;
            this.setDisclaimer();
        }

        $onInit() {
            this.accountService.getCards().then(
                () => this.setDisclaimer()
            );
        }

        setDisclaimer() {
            this.disclaimer = 'Add cards by saving them when you check out on your next order. You can save up to three cards.';
            if(this.accountService.data.cards.length >= 3) {
                this.disclaimer = 'You have reached the limit of three saved cards.';
            }
        }
    }
};
